

import { Component, OnInit} from '@angular/core';

@Component({
    selector: 'my-app',
    templateUrl: 'app.component.html',
    standalone: false
})

export class AppComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
